import React from "react";
import { useNavigate } from "react-router";
import { FormProvider, useForm } from "react-hook-form";

import { yupResolver } from "@hookform/resolvers/yup";

import Box from "@mui/material/Box";

import Button from "components/Button";
import { FormInput } from "components/FormInput";

import { useAppDispatch, useAppSelector } from "store/hooks";
import { forgotPassword } from "store/features/authSlice";

import {
  ForgotPasswordFormValues,
  forgotPasswordValidationSchema,
} from "./validation";
import { routes } from "routes/routes";

import analytics from "services/analytics";
import { AnalyticsEvents } from "shared/constants/analytics";

interface ForgotPasswordFormProps {
  email: string;
  setEmail: (email: string) => void;
}

const ForgotPasswordForm: React.FC<ForgotPasswordFormProps> = (props) => {
  const { email, setEmail } = props;

  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const isLoading = useAppSelector((state) => state.auth.isLoading);

  const methods = useForm<ForgotPasswordFormValues>({
    mode: "onSubmit",
    resolver: yupResolver(forgotPasswordValidationSchema),
    values: {
      email: email,
    },
  });

  const onSubmit = methods.handleSubmit(
    async (values: ForgotPasswordFormValues) => {
      analytics().sendEvent(AnalyticsEvents.forgot_password_send_email);

      await dispatch(
        forgotPassword({
          email: values.email,
        }),
      )
        .unwrap()
        .then(() => {
          setEmail(values.email);
        });
    },
  );

  const onGoBack = () => {
    analytics().sendEvent(AnalyticsEvents.forgot_password_go_back);
    methods.reset();
    navigate(routes.auth, { replace: true });
  };

  return (
    <Box>
      <FormProvider {...methods}>
        <FormInput title="Email" name="email" fullWidth type="email" />
      </FormProvider>

      <Button
        sx={{ mb: 2 }}
        variant="contained"
        color="primary"
        fullWidth
        onClick={onSubmit}
        loading={isLoading}
      >
        Надіслати
      </Button>
      <Button
        variant="contained"
        color="secondary"
        fullWidth
        withBorder
        onClick={onGoBack}
        disabled={isLoading}
      >
        Повернутись
      </Button>
    </Box>
  );
};

export default ForgotPasswordForm;
